<template>
  <form class="container questions">
    <div v-if="!smooching && load">
      <div class="row">
        <div class="col">
          <h1 class="questions__intro">Hello! Let me help you write a sonnet for your sweetheart!</h1>
        </div>
      </div>
      <div class="row">
        <div class="col col--12">
          <div class="questions__container">
            <div class="questions__stack"></div>
            <transition-group name="flip">
              <div class="questions__card" :key="i" v-for="(elements, i) in formElements" v-show="currentQuestion === i">
                <label class="questions__label">{{formElements[currentQuestion].label}}</label>
                <input :id="`question-${i}`" class="questions__input" v-model="answers[i]" type="text" :placeholder="formElements[currentQuestion].placeholder" v-if="formElements[currentQuestion].type === 'text'">
                <div class="questions__select-container" v-if="formElements[currentQuestion].type === 'select'">
                  <select :id="`question-${i}`" class="questions__select" v-model="answers[i]">
                    <option :key="option" v-for="option in formElements[currentQuestion].options" :value="option">{{capitalize(option)}}</option>
                  </select>
                </div>
              </div>
            </transition-group>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col--12">
          <div class="questions__pagers">
            <span :key="i" v-for="(elements, i) in formElements" v-bind:class="{'questions__pager-dot':true, 'questions__pager-dot--active':(currentQuestion === i)}"></span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col--12">
          <button class="questions__next" @click.prevent="next" v-if="!isLastQuestion" :disabled="currentQuestionIsInvalid">Continue</button>
          <button class="questions__submit" @click.prevent="submit" v-if="isLastQuestion">Show me the poem!</button>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-if="smooching">
        <div class="row">
          <div class="col">
            <h1 class="questions__intro">Okay, I'm writing a poem for {{answers[1]}}...<br><br>One moment...</h1>
            <div class="questions__heart-beat"><img src="/static/img/r_heart.svg" class="questions__heart"></div>
          </div>
        </div>
      </div>
    </transition>
  </form>
</template>

<script>
import router from '../router'

export default {
  name: 'Questions',

  data () {
    return {
      answers: [],
      currentQuestion: 0,
      load: false,
      showQuestion: true,
      smooching: false
    }
  },

  computed: {
    currentQuestionIsInvalid () {
      return this.formElements[this.currentQuestion].type === 'text' &&
          !this.answers[this.currentQuestion]
    },

    formElements () {
      return [
        {
          'label': 'I first need to know who you are. So tell me your name...',
          'key': 'author',
          'type': 'text',
          'placeholder': 'Your name'
        },
        {
          'label': 'Now tell me the name of your sweetheart!',
          'key': 'name',
          'type': 'text',
          'placeholder': 'Your sweetheart\'s name'
        },
        {
          'label': `What is ${this.loverName}'s favorite color?`,
          'key': 'color',
          'type': 'select',
          'options': [
            'red', 'orange', 'yellow', 'blue', 'green', 'purple', 'black', 'brown', 'grey', 'white'
          ],
          'selectedOption': 'red'
        },
        {
          'label': `What is ${this.loverName}'s favorite season?`,
          'key': 'color',
          'type': 'select',
          'options': [
            'spring', 'summer', 'fall', 'winter'
          ],
          'selectedOption': 'spring'
        },
        {
          'label': `${this.loverName} has nice:`,
          'key': 'color',
          'type': 'select',
          'options': [
            'hands', 'lips', 'cheeks', 'eyes', 'hair'
          ],
          'selectedOption': 'hands'
        }
      ]
    },

    isLastQuestion () {
      return this.currentQuestion + 1 === this.formElements.length
    },

    loverName () {
      return this.answers[1]
    },

    yourName () {
      return this.answers[0]
    }
  },

  methods: {
    capitalize (word) {
      return word.charAt(0).toUpperCase() + word.slice(1)
    },

    compileData () {
      let formData = {}
      let queries = []

      this.formElements.forEach((formEl, i) => {
        if (i === 0 || i === 1) {
          formData[formEl.key] = this.answers[i]
        } else {
          queries.push(this.answers[i])
        }
      })

      formData.queries = queries.join(',')

      return formData
    },

    next () {
      if (!this.answers[this.currentQuestion]) {
        return false
      }

      if (this.showQuestion) {
        this.currentQuestion++

        this.setDefaultOption()

        setTimeout(() => {
          document.getElementById(`question-${this.currentQuestion}`).focus()
        }, 0)
      }
    },

    setDefaultOption () {
      if (this.formElements[this.currentQuestion].type === 'select') {
        this.answers[this.currentQuestion] = this.formElements[this.currentQuestion].options[0]
      }
    },

    submit () {
      const smoochData = this.compileData()

      this.smooching = true

      this.$http.post('/api/hugs/v1/smooch', smoochData, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then((response) => {
        return response.json()
      }, (response) => {
        router.push({name: 'Poem'})
      }).then((data) => {
        this.load = false
        this.smooching = false

        setTimeout(() => {
          router.push({name: 'Poem', query: {poemId: data.poem_id}})
        }, 750)
      })
    }
  },

  mounted () {
    setTimeout(() => {
      this.load = true
    }, 0)
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/sass/placeholders';
@import '../assets/sass/variables';

.questions {
  background: transparent url('/static/img/p_sml_heart.svg') repeat-x 0 10px;
  overflow-x: hidden;

  @include from-breakpoint(md) {
    padding: 64px 0 0;
  }
}

.questions__container {
  height: 280px;
  margin: 30px auto;
  max-width: 320px;
  position: relative;
  width: 100%;

  @include from-breakpoint(md) {
    height: 375px;
    max-width: 480px;
  }
}

.questions__intro {
  @extend %h5;

  color: $pink-2;
  font-size: 21px;
  margin: 2em 0 0;

  @include from-breakpoint(md) {
  font-size: 26px;
    margin: 0 0 1em;
  }
}

.questions__stack {
  background: $white;
  height: calc(100% - 1px);
  position: absolute;
  width: 100%;

  &::after {
    background: $white;
    border: 1px solid $grey-3;
    content: '';
    height: 10px;
    left: 20px;
    position: absolute;
    top: -19px;
    width: calc(100% - 40px);
  }

  &::before {
    background: $white;
    border: 1px solid $grey-3;
    content: '';
    height: 10px;
    left: 10px;
    position: absolute;
    top: -10px;
    width: calc(100% - 20px);
  }
}

.questions__card {
  background: $white;
  border: 1px solid $grey-3;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 30px;
  position: absolute;
  top: -1px;
  width: 100%;

  @include from-breakpoint(md) {
    padding: 30px 64px;
  }
}

.questions__label {
  @extend %h3;

  align-items: center;
  color: $grey-5;
  display: flex;
  flex: 1 0 auto;
  font-size: 26px;
  font-weight: 300;
  line-height: 1;
  margin: 0 auto 30px;
  text-align: center;

  @include from-breakpoint(md) {
    font-size: 32px;
  }
}

.questions__pagers {
  margin-bottom: 30px;
  text-align: center;
}

.questions__pager-dot {
  border: 2px solid $white;
  border-radius: 100%;
  display: inline-block;
  height: 12px;
  margin: 0 6px;
  transition: background-color $duration;
  width: 12px;
}

.questions__pager-dot--active {
  border: 1px solid $pink-1;
  background: $red-1;
}

.questions__input,
.questions__next {
  display: block;
  margin: 0 auto 30px;
}

.questions__select-container {
  position: relative;

  &::after {
    background: transparent url('/static/img/chevron-down.svg') no-repeat 0 0;
    content: ' ';
    height: 10px;
    position: absolute;
    right: 18px;
    top: 24px;
    width: 16px;
  }
}

.questions__select {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;

  &::-ms-expand {
    display: none;
  }

  &::-ms-value {
    background: none;
    color: $grey-6;
  }
}

.questions__next,
.questions__submit {
  @extend %cta;

  display: block;
  margin: 0 auto 30px;
}

.questions__heart-beat {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 100px 0 50px;
}

.questions__heart {
  animation: beat 1.5s ease-in-out infinite;
}

@keyframes beat {
  0%,
  25% {
    transform: scale(1);
  }

  35% {
    transform: scale(1.1);
  }

  45% {
    transform: scale(1);
  }

  60% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Questions.vue